import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function AdminEmailStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.adminEmail")}</h2>

      <input
        ref={inputRef}
        type="email"
        value={formData.adminEmail}
        onChange={e =>
          setFormData({ ...formData, adminEmail: e.target.value })
        }
      />

      <p className="muted">
        {t("Start.info.adminEmail")}
      </p>
    </>
  );
}
